module.exports = {"371702001":"东城街道","371702002":"西城街道","371702003":"南城街道","371702004":"北城街道","371702005":"牡丹街道","371702009":"何楼街道","371702100":"沙土镇","371702101":"吴店镇","371702102":"王浩屯镇","371702103":"黄堽镇","371702104":"都司镇","371702105":"高庄镇","371702106":"小留镇","371702107":"李村镇","371702108":"马岭岗镇","371702109":"安兴镇","371702110":"大黄集镇","371702112":"胡集镇","371702202":"皇镇乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371702.json
// module id = 1379
// module chunks = 0